import React, { ReactNode } from 'react';
import { Stack, StackProps, Typography } from '@mui/material';

export const ContentBlock = ({
  label = '',
  content = '',
  ...rest
}: StackProps & {
  label: string;
  content: ReactNode;
}) => {
  return (
    <Stack {...rest}>
      <Typography variant="caption" color="secondary.extraLight">
        {label}:
      </Typography>
      <Typography component="span" sx={{ wordBreak: 'break-all' }}>
        {content}
      </Typography>
    </Stack>
  );
};
